export const SVGNS = 'http://www.w3.org/2000/svg';
export function $(selector) {
    return Array.from(document.querySelectorAll(selector));
}
export function $$opt(selector) {
    const e = (/^[a-zA-Z0-9-]+$/.test(selector) && selector != 'body') ? document.getElementById(selector) : document.querySelector(selector);
    if (!(e instanceof HTMLElement))
        return undefined;
    return e;
}
export function $$(selector) {
    const e = $$opt(selector);
    if (!(e instanceof HTMLElement))
        throw new Error(`Element not found for selector '${selector}'. ${e ? 'No match.' : 'Element is not an HTMLElement.'}`);
    return e;
}
export function setAttrs(e, attributeMap) {
    if (attributeMap)
        for (const name in attributeMap) {
            if (name != 'style' || typeof attributeMap[name] == 'string') {
                if (attributeMap[name] == null)
                    e.removeAttribute(name);
                else
                    e.setAttribute(name, attributeMap[name]);
            }
            else
                for (const style in attributeMap.style)
                    e.style[style] = attributeMap.style[style];
        }
}
export function newTxt(text) {
    return document.createTextNode(text);
}
export function newElem(ns, name, attributeMap, children) {
    const e = ns ? document.createElementNS(ns, name) : document.createElement(name);
    setAttrs(e, attributeMap);
    if (Array.isArray(children))
        for (const child of children)
            if (typeof child === 'string')
                e.appendChild(newTxt(child));
            else
                e.appendChild(child);
    else if (typeof children === 'string')
        e.appendChild(newTxt(children));
    else if (children)
        e.appendChild(children);
    return e;
}
export function newHtml(name, attributeMap, children) {
    return newElem(undefined, name, attributeMap, children);
}
export function newSvg(name, attributeMap, children) {
    return newElem(SVGNS, name, attributeMap, children);
}
export function addHtml(parent, name, attributeMap, children) {
    const e = newElem(undefined, name, attributeMap, children);
    parent.appendChild(e);
    return e;
}
export function addSvg(parent, name, attributeMap, children) {
    const e = newElem(SVGNS, name, attributeMap, children);
    parent.appendChild(e);
    return e;
}
export function removeAllChildren(e, selector) {
    if (selector) {
        for (const c of Array.from(e.querySelectorAll(selector)))
            removeAllChildren(c);
    }
    else
        while (e.firstChild)
            e.removeChild(e.firstChild);
}
export function setText(parent, selector, text) {
    const e = parent.querySelectorAll(selector);
    for (let i = 0; i < e.length; i++)
        e[i].textContent = text;
}
export function setDisplay(parent, selector, newValue) {
    const e = selector ? Array.from(parent.querySelectorAll(selector)) : [parent];
    for (const el of e) {
        if (el instanceof HTMLElement || el instanceof SVGElement)
            el.style.display = newValue;
    }
}
